import { Button } from "@gcs/design-system/react";
import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
  borderRadius: "16px",
  border: "1px solid #E3E0E2",
  padding: "12px",
  width: "40%",
  [theme.breakpoint.lg()]: {
    borderRadius: "4px",
    padding: "20px",
    width: "25%",
  },
}));
export const Buttons = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingTop: " 10px",
}));

export const PStyled = styled.p(({ theme }) => ({
  fontSize: "19px",
  fontWeight: 700,
  margin: "0",
  paddingBottom: "12px",
  height: "52px",
  lineHeight: "36px",
  [theme.breakpoint.lg()]: {
    marginBottom: "0px",
  },
}));

export const Line = styled.div(() => ({
  borderBottom: "1px solid #E3E0E2",
}));
export const Link = styled.a(() => ({
  textDecoration: "none",
  "&:visited": {
    color: "#005FC8",
  },
}));

export const ButtonStyled = styled(Button).attrs({ variant: "tertiary-01-sm" })(
  ({ theme }) => ({
    color: "#005FC8",
    fontSize: "14px",
    [theme.breakpoint.lg()]: {
      fontSize: "19px",
    },
  })
);
